var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29723 36.7355C3.29723 36.7355 0.245117 36.7355 0.245117 33.6833C0.245117 30.6312 3.29723 21.4749 18.5578 21.4749C33.8184 21.4749 36.8705 30.6312 36.8705 33.6833C36.8705 36.7355 33.8184 36.7355 33.8184 36.7355H3.29723ZM18.5578 18.4228C20.9862 18.4228 23.3152 17.4581 25.0323 15.741C26.7494 14.0238 27.7141 11.6949 27.7141 9.26644C27.7141 6.83803 26.7494 4.50908 25.0323 2.79194C23.3152 1.07479 20.9862 0.110107 18.5578 0.110107C16.1294 0.110107 13.8004 1.07479 12.0833 2.79194C10.3661 4.50908 9.40145 6.83803 9.40145 9.26644C9.40145 11.6949 10.3661 14.0238 12.0833 15.741C13.8004 17.4581 16.1294 18.4228 18.5578 18.4228Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGray);
export default __webpack_public_path__ + "static/media/PersonGray.b48d73fdbac376347b65be90d1467c5b.svg";
export { ForwardRef as ReactComponent };